module.exports = __webpack_public_path__ + "static/img/008.d368c20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/008.png
// module id = lDxP
// module chunks = 1